import axios from 'axios';

import { LOGGING_API_REGISTER_STEP } from '../constants/constants';

export const axiosGetInstance = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const axiosIntanceVinco = axios.create({
  baseURL: LOGGING_API_REGISTER_STEP,
});
